import DelaysManager from "../../pages/delays/manager";
import DelaysParetoReport from "../../pages/delays/pareto";

export const routeDelaysManager = "/delays/manager";
export const routeDelaysPareto = "/delays/pareto";

export const delayRoutes = [
	{
		path: `${routeDelaysManager}/:shiftId`,
		element: <DelaysManager />,
	},
	{
		path: `${routeDelaysManager}`,
		element: <DelaysManager />,
	},
	{
		path: `${routeDelaysPareto}`,
		element: <DelaysParetoReport />,
	},
];
